export default "__VITE_ASSET__BYujvk1i__"